/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/updateProfile.config.json";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  firstName: string;
  lastName: string;
  occupation: string;
  telephone: string;
  address: string;
  city: string;
  country: string;
  profileImage: any;
}

export class UpdateProfileService implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    console.log("data in mutation", args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_MY_PROFILE,
          variables: {
            updateMyProfileInput2: {
              firstName: args?.firstName,
              lastName: args?.lastName,
              occupation: args?.occupation,
              primaryContactNo: args?.telephone,
              address: {
                addressLine1: args?.address,
                city: args?.city,
                country: args?.country,
              },
              image: args?.profileImage?.base64,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    return { data: config };
  }
}
